import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import './yarn-type-list.scss';
import * as Yup from 'yup';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import YarnTypeService from '../../services/yarn-type.service';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import yarnTypeService from '../../services/yarn-type.service';
// import transporterService from '../../services/transporter.service';
// import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
// import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import moment from 'moment';
import CheckDuplicate from '../check-duplicate/check-duplicate'

export default function YarnTypeEdit(props) {
    console.log('selectedRow--->',props)
    const [yarnType,setYarnType] = useState(props.YarnType)
    const [yarnTypeID,setYarnTypeID] = useState(props.YarnTypeID)
    const [yarnTypeChange,setYarnTypeChange] = useState()
    const [yarnTypeShort,setyarnTypeShort] = useState(props.YarnTypeShort)
    const [yarnTypeShortChange,setYarnTypeShortChange] = useState()
    const [checkDuplicate, setCheckDuplicate] = useState(false);
    const [checkDuplicateValue, setCheckDuplicateValue] = useState('');
    const [yarnTypeValue, setYarnTypeValue] = useState(props.YarnType);
    const [yarnTypeShortValue, setYarnTypeShortValue] = useState(props.YarnTypeShort);
    useEffect(() => {
    setTimeout(() => {
      
      // YarnCountID ,YarnThread ,YarnQualityID ,YarnTypeID
     
      if(yarnTypeShortValue != undefined && yarnTypeValue != undefined  && checkDuplicate == true){
        console.log(props.dataList)
        let array = props.dataList.filter(obj=>obj.YarnTypeID !== props.YarnTypeID);
        console.log(array)
        let check = CheckDuplicate.withOutCombination(array,['YarnType','YarnTypeShort'],{
          YarnType:yarnTypeValue,
          YarnTypeShort:yarnTypeShortValue
        
        })
        console.log(check)
        
        if(!check){
          document.querySelector('#yarnTypesGrid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat').style.visibility='visible';
          setCheckDuplicateValue('')
        }else{
          document.querySelector('#yarnTypesGrid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat').style.visibility='hidden';
          setCheckDuplicateValue('Duplicate Value Detected!')
      }
     }
    }, 500);
    }, [yarnTypeValue ,yarnTypeShortValue]);  
  const useStyles = makeStyles((theme) => ({
    fromWrapper: {
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(8),
    },
  }));

  useEffect(() => {
    setTimeout(() => {
      setCheckDuplicate(true)
    }, 500);
    // getYarnCompanies();
    // getYarnBrands();
    // getProcurementTypes();
    // getCurrencies();
    // getDeliveryStatus();
    // getPaymentTerms();
    // getImportLCs();
    // getFullYarnCounts();
  }, []);

  const changeYarnType = (e) =>{
      setYarnTypeChange(e.value)
  }

  const ChangeYarnTypeShort = (e)=>{
      setYarnTypeShortChange(e.value)
  }


  const INITIAL_FORM_STATE = {
    // TransporterId: '',
    YarnType: '',
    YarnTypeShort: '',
  };

  const FORM_VALIDATION = Yup.object().shape({
    // OrderId: Yup.string().required('Required'),
    YarnType: Yup.string().required('Required'),
    YarnTypeShort: Yup.string().required('Required'),
  });

  
  const fields: object = { text: 'value', value: 'id' };

  const classes = useStyles();

  const minDate: Date = new Date(moment().startOf('day'));


  return (
    <div className='yarn-type-container'  onKeyDown={(e)=>{
      console.log(e)
      if(e.keyCode == 13){
        e.stopPropagation()

      }
    }}>
      <div className='backgroundImg'></div>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div className='heading'>
            <h3 style={{ textAlign:'center', width: '100%' }}>Yarn Type - Edit</h3>
          </div>
        </Grid>

        <Grid item xs={12}>
          <Container>
            <div className={classes.fromWrapper}>
              <Formik
                initialValues={{
                  ...INITIAL_FORM_STATE,
                }}
                validationSchema={FORM_VALIDATION}
                onSubmit={async (values) => {
                  console.log('form values: ', values);
                  return new Promise((res) => {
                    YarnTypeService.create(values).then(
                      (response) => {
                        console.log('response: ', response);
                      }
                    );
                    setTimeout(res, 2500);
                  });
                }}
              >
                {({ values, errors, isSubmitting }) => (
                  <div>
                    {/* <pre> {JSON.stringify({ values, errors }, null, 4)} </pre> */}
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextBoxComponent
                          className='e-input'
                          type='text'
                          placeholder='Yarn Type'
                          name='YarnType'
                          floatLabelType='Auto'
                          value={yarnTypeValue}
                          onChange={(e)=>setYarnTypeValue(e.value)}
                        />
                        <TextBoxComponent 
                        type='hidden'
                        name='yarnTypeID'
                        value={yarnTypeID}
                        />

                        
                      </Grid>
                      
                      <Grid item xs={12}>
                        <TextBoxComponent
                          className='e-input'
                          type='text'
                          placeholder='Yarn Type (Short)'
                          name='YarnTypeShort'
                          floatLabelType='Auto'
                          value={yarnTypeShortValue}
                          onChange={(e)=>setYarnTypeShortValue(e.value)}
                          // onChange={updateCalculations}
                          blur={()=>{
                            if(checkDuplicateValue == '' && yarnTypeShortValue != undefined){
                              setTimeout(()=>document.querySelector('#yarnTypesGrid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat').focus(),600);

                            }
                          }}
                        />
                      </Grid>

                    </Grid>
                  </div>
                )}
              </Formik>
            </div>
          </Container>
        </Grid>
      </Grid>
      <h3 className="duplicate " style={checkDuplicateValue != '' ? {transform:'scale(1)'}:{}}>{checkDuplicateValue}</h3>

    </div>
  );
}
